import { AlarmTypeDisplays, EventType } from "../../../enums/eventType";
import { RoomStatusAlarmNameDisplay } from "../../../enums/roomStatusAlarmName";
import { SystemErrorNameDisplay } from "../../../enums/systemErrorName";
import { EventTypeOption } from "../events/ManagementEventOptions";

export const ALARM_EVENT_TYPE_OPTIONS = Array.from(AlarmTypeDisplays);

export const EVENT_TYPE_NAME_OPTIONS: EventTypeOption[] = ALARM_EVENT_TYPE_OPTIONS.map((eventType): EventTypeOption => {
    return {
        value: eventType[0],
        label: eventType[1],
        eventNames: getEventNameOptions(eventType[0]).map((eventName) => {
            return { value: eventName[0], label: eventName[1] };
        })
    };
});

export function getEventNameOptions(eventType: number | null): [number, string][] {
    switch (eventType) {
        case EventType.RoomStatusAlarm:
            return Array.from(RoomStatusAlarmNameDisplay);
        case EventType.SystemError:
            return Array.from(SystemErrorNameDisplay);
        default:
            return [];
    }
}
